import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Star, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { Container } from "../components/site/Reveal";
import { useSite } from "../context/SiteContext";

const LeaveReview = () => {
  const { t } = useSite();
  const nav = useNavigate();
  const [form, setForm] = useState({ code: "", contact: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => { document.title = "Leave a Review | StripWise"; }, []);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { const { data } = await api.post("/reviews/verify", form); nav(`/review/${data.token}`); }
    catch (e2) { setErr(e2?.response?.data?.detail || t("Something went wrong")); }
    finally { setBusy(false); }
  };
  const inp = "mt-1.5 w-full rounded-xl border border-[#dcebe8] bg-white px-4 py-3 text-[15px] outline-none focus:border-[#0e8c7f]";
  return (
    <section className="bg-[#f4fbf9] py-16 md:py-24" data-testid="leave-review-page">
      <Container className="max-w-xl">
        <div className="flex text-[#f59e0b]">{[...Array(5)].map((_, i) => <Star key={i} size={22} fill="currentColor" />)}</div>
        <h1 className="sw-h2 mt-4">{t("Leave a Review")}</h1>
        <p className="mt-3 text-[16.5px] leading-relaxed text-[#4b5d5a]">{t("Already been paid by StripWise? We'd love to hear how it went. Enter your quote number and the email or phone number you used, so we know you're a real customer.")}</p>
        <form onSubmit={submit} className="sw-card mt-8 space-y-4 p-6 md:p-8">
          <label className="block text-[14px] font-semibold text-[#0f2e2a]">{t("Quote number")}
            <input required value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} placeholder="SW-12345" className={inp} data-testid="leave-review-code" />
          </label>
          <label className="block text-[14px] font-semibold text-[#0f2e2a]">{t("Email or phone number")}
            <input required value={form.contact} onChange={(e) => setForm({ ...form, contact: e.target.value })} className={inp} data-testid="leave-review-contact" />
          </label>
          {err && <p className="rounded-xl bg-[#fff3f2] px-4 py-3 text-[14px] text-[#b42318]" data-testid="leave-review-error">{err}</p>}
          <button disabled={busy} className="sw-btn-primary w-full justify-center disabled:opacity-60" data-testid="leave-review-submit">{busy && <Loader2 size={16} className="animate-spin" />}{t("Continue")}</button>
        </form>
      </Container>
    </section>
  );
};

export default LeaveReview;
